import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';

//material core
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

//material icons
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Grid from '@material-ui/core/Grid';
import PerfectScrollbar from 'react-perfect-scrollbar';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide/Slide';
import {Divider} from '@material-ui/core';

import useHook from './legend.hooks';

const useStyles = makeStyles((theme) => ({
  //button
  button: {
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#f4f4f4',
    },
    position: 'absolute',
    right: 0,
    bottom: 250,
    float: 'right',
    paddingLeft: 5,
    paddingRight: 5,
    minWidth: 30,
    borderRadius: '0px 0px 0px 0px',
  },

  buttonShow: {
    display: 'none',
    // position: 'absolute',
    // right: 254,
    // bottom: 250,
    // float: 'right',
    // paddingLeft: 0,
    // paddingRight: 4,
    // minWidth: 30,
    // borderRadius: '8px 0px 0px 8px',
    // boxShadow: '0px -5px 5px 0px rgba(0,0,0,0.12)',
    // '&:hover': {
    //     boxShadow: '0px -3px 5px 0px rgba(0,0,0,0.25)',
    // },
  },

  //legend content
  box: {
    width: 250,
    padding: '0.5vh',
    paddingBottom: 25,
    height: 283,
    position: 'absolute',
    bottom: theme.spacing(0),
    right: theme.spacing(0),
    margin: theme.spacing(0),
    backgroundColor: 'white',
  },

  //legend item
  item: {
    padding: 1,
    marginRight: 10,
    paddingLeft: 20,
  },
}));

const LegendLeft = (props) => {
  const classes = useStyles();
  const [{legend}] = useHook(props);

  const [checked, setChecked] = React.useState(false);
  const handleChange = () => {
    document.body.style.overflow = 'hidden';
    setChecked((prev) => !prev);
  };

  const ListLegend = (props1) => {
    const {data} = props1;
    return (
      <Grid item xs={12} style={{fontSize: 12, marginLeft: 10}}>
        <i className={classes.item} style={{backgroundColor: data.warna}} />
        {data.label}
      </Grid>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      document.body.style.overflow = 'unset';
    }, 300);
  }, [checked]);

  return (
    <div>
      <Button
        variant="contained"
        color="default"
        size="small"
        className={!checked ? classes.button : classes.buttonShow}
        onClick={handleChange}>
        <KeyboardArrowLeftIcon style={{fontSize: 25}} />
      </Button>

      <Slide direction="left" in={checked} mountOnEnter unmountOnExit>
        <Box className={classes.box} boxShadow={3}>
          <Grid container>
            <Grid
              item
              xs={10}
              style={{
                alignSelf: 'center',
                textAlign: '-webkit-center',
                width: 200,
              }}>
              Legend
            </Grid>
            <Grid item xs={2}>
              <IconButton onClick={handleChange} size="small">
                <KeyboardArrowRightIcon style={{fontSize: 25}} />
              </IconButton>
            </Grid>
          </Grid>

          <Divider
            style={{
              marginTop: 5,
              marginBottom: 10,
              marginLeft: 10,
              marginRight: 10,
            }}
          />

          <PerfectScrollbar options={{suppressScrollX: true}} style={{height: '83%'}}>
            <Grid container spacing={1}>
              {legend.map((value, key) => {
                return <ListLegend data={value} key={key} />;
              })}
            </Grid>
          </PerfectScrollbar>
        </Box>
      </Slide>
    </div>
  );
};

export default LegendLeft;
